import 'css-chunksrc/client/pages/utilityPage/projectPage/projectStatusesList/projectStatusCreation/form/styles.scss';export default {
  "form": "_form_t7q6f_1",
  "iconBox": "_iconBox_t7q6f_15",
  "icon": "_icon_t7q6f_15",
  "input": "_input_t7q6f_31",
  "colorPicker": "_colorPicker_t7q6f_47"
};